import { DisplayMode } from '@api-consent/types/common';
import type { TefComs4csMicroFrontend } from '@mfe-4cs/components/tef-coms4cs';
import { replaceElements } from '@mfe-4cs/components/templates/util';
import { html, nothing, TemplateResult } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export function mainTemplate(this: TefComs4csMicroFrontend): TemplateResult {
  const occlClasses = this.store.occl?.getStyleContextClasses() ?? [];
  const classes = [
    ...occlClasses,
    'tef-coms',
    'section',
    'section--size-flat',
  ];

  const historyTemplate = this.getTemplateFn('historyTemplate');
  const groupTemplate = this.getTemplateFn('groupTemplate');
  const groupTemplateOverview = this.getTemplateFn('groupTemplateOverview');
  const referencesTemplate = this.getTemplateFn('referencesTemplate');

  let content;
  if (this.store.history?.configId) {
    content = historyTemplate();
  } else {
    content = this.displayConsentGroups?.filter((group) => group.displayMode !== DisplayMode.HIDDEN)
      .map((group) => (this.mode === 'overview'
        ? groupTemplateOverview(group)
        : groupTemplate(group)));
  }

  return html`
    <div class=${classes.join(' ')}>
      ${this.showReferences ? referencesTemplate(this.store.references) : nothing}
      ${content}

      ${((this.displayConsentGroups?.length ?? 0) > 0 && this.store.details?.pageFooter)
    ? html`<p>${unsafeHTML(replaceElements.bind(this)(this.store.details.pageFooter))}</p>`
    : nothing}
    </div>
  `;
}
